import React from 'react';
import Icon from '../../../components/AppIcon';

const DataRightsCard = () => {
  const rights = [
    {
      icon: "Eye",
      title: "Access Your Data",
      description: "Request a copy of all personal information we have about you"
    },
    {
      icon: "Edit",
      title: "Correct Information",
      description: "Update or correct any inaccurate personal data we hold"
    },
    {
      icon: "Trash2",
      title: "Delete Your Data",
      description: "Request deletion of your personal information from our systems"
    },
    {
      icon: "Download",
      title: "Data Portability",
      description: "Receive your data in a structured, machine-readable format"
    },
    {
      icon: "Ban",
      title: "Restrict Processing",
      description: "Limit how we use your personal information"
    },
    {
      icon: "UserX",
      title: "Withdraw Consent",
      description: "Opt-out of data processing based on your consent"
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 liquid-shadow">
      <h3 className="text-xl font-poppins font-bold text-primary mb-4 flex items-center">
        <Icon name="UserCheck" size={24} className="mr-3 text-accent" />
        Your Data Rights
      </h3>
      <p className="text-text-secondary mb-6 text-sm leading-relaxed">
        You have complete control over your personal information. Exercise these rights at any time:
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {rights?.map((right, index) => (
          <div key={index} className="flex items-start space-x-3 p-4 bg-surface rounded-lg hover:bg-muted brand-transition">
            <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <Icon name={right?.icon} size={16} className="text-primary" />
            </div>
            <div>
              <h4 className="font-inter font-semibold text-text-primary text-sm mb-1">
                {right?.title}
              </h4>
              <p className="text-text-secondary text-xs leading-relaxed">
                {right?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DataRightsCard;